import { observable } from "mobx";
import DeadLetterTopicMessageResponse from "./deadLetterTopicMessageResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DeadLetterTopicMessageDetailResponse extends DeadLetterTopicMessageResponse {
  @observable
  chargeId!: string;

  @observable
  chargeOrderId!: string;

  @observable
  messageRequestId!: string;
}
